import RequestAbstract from "../abstract";

export default class Roles extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/roles";
    }

}
